// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_IndexResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * PlanoMetas Index Response Contract
 *
 * Response for GET /plano_metas - List all goal plans (planos de metas)
 *
 * @package Contracts
 */
import type { PlanoMetas_IndexRow } from './PlanoMetas_IndexRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlanoMetas_IndexResponseDados {
items: PlanoMetas_IndexRow[]
}

export type PlanoMetas_IndexResponse = ApiResponse<PlanoMetas_IndexResponseDados>;

registerResponseContract('PlanoMetas_IndexResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      id:                    { type: 'number',  required: true },
      franquia_id:           { type: 'number',  required: true },
      data_inicial:          { type: 'string',  required: true },
      data_final:            { type: 'string',  required: true },
      meta_faturamento:      { type: 'number',  required: false },
      meta_clientes:         { type: 'number',  required: false },
      numero_dias_uteis:     { type: 'number',  required: false },
      ticket_medio_esperado: { type: 'number',  required: false },
      status:                { type: 'string',  required: true },
      observacao:            { type: 'string',  required: false },
      created_by:            { type: 'number',  required: false },
      deleted_at:            { type: 'string',  required: false },
      created_at:            { type: 'string',  required: true },
      updated_at:            { type: 'string',  required: true },
      periodo_formatado:     { type: 'string',  required: true },
    },
  },
})
